<template>
  <el-container style="height: 100vh;">
    <el-header height="50px"
      style="background-color: #f4f3f5; display: flex; align-items: center; justify-content: space-between;padding: 0px 20px;">
      <div style="display: flex; align-items: center;">
        <img src="./assets/logo.jpg" alt="App Logo" style="height: 30px; margin-right: 10px; border-radius: 5px;" />
        <h1 style="font-size: 18px;">TOYNAME</h1>
      </div>
      <div style="display: flex; align-items: center;" @click="handleClick">
        <span style="direction: rtl;">
          {{ isAuthenticated ? shopInfo.nameZh : '商家入口' }}
        </span>
        <el-avatar v-if="isAuthenticated" style="margin-left: 10px;" :size="30" :src="shopInfo.avatar" />

      </div>

    </el-header>

    <el-main style="background-color: #ffffff; overflow: auto;">
      <router-view></router-view>
    </el-main>

    <el-footer
      style="background-color: #f4f3f5; height: 70px; display: flex; align-items: center; justify-content: center; flex-direction: column;">
      <p style="margin: 0;">© 2025 海南兴星谷科技有限公司 . 保留所有权利.</p>
      <p style="margin: 0; font-size: 12px; color: #333;">ICP备案号:琼ICP备2023001668号-1</p>
    </el-footer>
  </el-container>

</template>

<script>
import { computed, onMounted, } from 'vue';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
import { get } from '@/api/http';


export default {
  name: 'App',
  setup() {
    const store = useStore();
    const router = useRouter();

    // 获取用户的登录状态
    const isAuthenticated = computed(() => store.getters.isAuthenticated);

    const shopInfo = computed(() => {
      const shop = store.state.shop;
      return shop ? shop : {}; // 如果用户信息存在，返回用户名，否则返回空字符串
    });

    onMounted(() => {
      getData();
    });

    const getData = async () => {

      if (shopInfo.value == null) {
        store.commit('logout');
      }


      try {
        const response = await get('adminShop/shop')
        if (response.code != 200) {
          store.commit('logout');
        }
      } catch (error) {
        store.commit('logout');
        console.error('请求失败', error)
      }
    }


    const handleClick = () => {
      if (isAuthenticated.value) {

        if (router.currentRoute.value.name === 'Home') {
          switch (shopInfo.value.type) {

            case 23:
              router.replace({ name: 'Photos' })
              break;
            case 7:
              router.replace({ name: 'Dress' })
              break;
            case 8:
              router.replace({ name: 'MakeUp' })
              break;
            case 9:
              router.replace({ name: 'Emcee' })
              break;
            case 10:
              router.replace({ name: 'Plan' })
              break;
            case 11:
              router.replace({ name: 'Car' })
              break;
            case 12:
              router.replace({ name: 'Restaurant' })
              break;
          }

        } else {
          // 如果不是 Home 界面，显示退出确认弹框
          ElMessageBox.confirm(
            '确定要退出么?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              ElMessage({
                type: 'success',
                message: '退出成功',
              });

              // 执行退出操作
              store.commit('logout');

              // 返回上一页或跳转到 Home 界面
              router.back(); // 返回上一页
              // 或者跳转到 Home 界面
              // router.push({ name: 'Home' });
            })
            .catch(() => {
              // 用户取消退出操作
            });
        }
      } else {
        // 如果未登录，跳转到登录页
        router.push({ name: 'Login' });
      }
    };

    return {
      isAuthenticated,
      handleClick,
      shopInfo
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  font-size: 12px;
}

.el-main {
  padding: 0;
}
</style>
